import * as z from "zod/v4";
import { trackstarConnectionsSchema } from "./get-trackstar-connections";

export enum TrackstarConnectionType {
  RETURN = "return",
  OMS = "oms",
}

export const exchangeTrackstarAuthCode = {
  name: "exchangeTrackstarAuthCode" as const,
  input: z.object({
    authCode: z.string(),
    connectionType: z.enum(TrackstarConnectionType),
  }),
  output: z.object({ connection: trackstarConnectionsSchema }),
};
